import { useTranslation } from 'react-i18next';
import { useUpdateDocumentTitle } from '@anytag/shared-hooks';
import { SignInSignUpLayout, TermsAnytagEn, TermsJP } from '@anytag/shared-organisms';
import { Language } from '@anytag/shared-types';
import { useAuthData } from '@anytag/auth';

export const TermsOfService = () => {
  useUpdateDocumentTitle({ title: 'documentTitle.Terms' });
  const { i18n } = useTranslation();
  const { defaultRoute } = useAuthData();
  return (
    <SignInSignUpLayout
      footerProps={{ className: { paddingBottom: '85px' } }}
      headerProps={{ to: defaultRoute, className: { paddingTop: '40px' } }}
    >
      {i18n.language === Language.ja ? <TermsJP /> : <TermsAnytagEn />}
    </SignInSignUpLayout>
  );
};
